import type {JSONContent} from "@tiptap/core";

export const MIN_PRINTOUT_CONTAINER_COLUMNS = 1;
export const MAX_PRINTOUT_CONTAINER_COLUMNS = 6;
export const DEFAULT_PRINTOUT_CONTAINER_COLUMNS = 2;

export const PRINTOUT_CONTAINER_COLUMN_GAP_MM = 8;
export const PRINTOUT_CONTAINER_SPACE_ABOVE_OPTIONS = [0, 4, 8, 12] as const;

export const normalizePrintoutContainerSpaceAbove = (value: unknown): number => (
    (PRINTOUT_CONTAINER_SPACE_ABOVE_OPTIONS as readonly number[]).includes(Number(value))
        ? Number(value)
        : 0
);

export const clampPrintoutContainerColumns = (
    value: unknown,
    fallback = DEFAULT_PRINTOUT_CONTAINER_COLUMNS,
): number => {
    const numberValue = typeof value === "number" ? value : Number(value);

    if (!Number.isFinite(numberValue)) return fallback;

    return Math.min(
        MAX_PRINTOUT_CONTAINER_COLUMNS,
        Math.max(MIN_PRINTOUT_CONTAINER_COLUMNS, Math.round(numberValue)),
    );
};

export const createPrintoutContainerColumnJson = (content?: JSONContent[]): JSONContent => ({
    content: content?.length ? content : [{type: "paragraph"}],
    type: "printoutContainerColumn",
});

export const createPrintoutContainerColumnsJson = (count: number): JSONContent[] => (
    Array.from({length: clampPrintoutContainerColumns(count)}, () => createPrintoutContainerColumnJson())
);
